import { useContext } from 'react';
import { Me } from 'generated-types';
import { MeContext } from './MeProvider';

export const useMeContext = (): Me => useContext(MeContext) as Me;
